import type { JSX } from 'react';
import { Button, FormButtonRow } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

type ProcessActivityReadActionButtonRowProps = Readonly<{
    activityTitle: string;
    canBeCancelled: boolean;
    canBeRemoved: boolean;
    canCopyReadSectionsToClipboard: boolean;
    canEdit: boolean;
    canModify: boolean;
    canPrint: boolean;
    handleClickCancel: () => void;
    handleClickCopyReadSectionsToClipboard: () => Promise<void>;
    handleClickEdit: () => void;
    handleClickModify: () => void;
    handleClickPrint: () => void;
    onClickRemove: () => void;
}>;

export function ProcessActivityReadActionButtonRow({
    activityTitle,
    canBeCancelled,
    canBeRemoved,
    canCopyReadSectionsToClipboard,
    canEdit,
    canModify,
    canPrint,
    handleClickCancel,
    handleClickCopyReadSectionsToClipboard,
    handleClickEdit,
    handleClickModify,
    handleClickPrint,
    onClickRemove,
}: ProcessActivityReadActionButtonRowProps): JSX.Element | null {
    if (!canBeCancelled && !canCopyReadSectionsToClipboard && !canEdit && !canModify && !canPrint && !canBeRemoved) {
        return null;
    }

    return (
        <FormButtonRow>
            {canBeRemoved && (
                <Button
                    data-automation-test="processActivity-remove-button"
                    onClick={onClickRemove}
                    variant="outline"
                >
                    {getSelectedLanguage().common.remove}
                </Button>
            )}
            {canEdit && (
                <Button
                    key="edit"
                    onClick={handleClickEdit}
                >
                    {getSelectedLanguage().common.edit}
                </Button>
            )}
            {canCopyReadSectionsToClipboard && (
                <Button
                    iconLeft="copy"
                    key="copy"
                    onClick={handleClickCopyReadSectionsToClipboard}
                    variant="outline"
                >
                    {getSelectedLanguage().common.copy}
                </Button>
            )}
            {canPrint && (
                <Button
                    key="print"
                    onClick={handleClickPrint}
                    variant="outline"
                >
                    {getSelectedLanguage().request.statusAction_printReferral}
                </Button>
            )}
            {canModify && (
                <Button
                    key="modify"
                    onClick={handleClickModify}
                >
                    {getSelectedLanguage().processActivity.modify}
                </Button>
            )}
            {canBeCancelled && (
                <Button
                    color="danger"
                    key="cancel"
                    onClick={handleClickCancel}
                    variant="outline"
                >
                    {`${getSelectedLanguage().common.cancel} ${activityTitle}`}
                </Button>
            )}
        </FormButtonRow>
    );
}
